export const Texts = {
    DATE_FORMAT: 'dd/MM/yyyy',
    DATE_HH_FORMAT: 'dd/MM/yyyy HH',
    DATE_HH_MM_FORMAT: 'dd/MM/yyyy HH:mm',
    DATE_HH_MM_SS_FORMAT: 'dd/MM/yyyy HH:mm:ss',
    TIME_FORMAT: 'HH:mm',

    ALERT_MESSAGE_CONTENT_CONTINUE_BUTTON: 'Cerrar',
    ALERT_NON_AUTENTICATED_TILE: '',
    ALERT_NON_AUTENTICATED_MESSAGE: '',

    NO_MESSAGE: 'Sem mensagem para exibir'
}
